import { SortOptions } from '@ch/common/types/data';
import { optionsNormalize } from '@ch/common/utils/helpers';
import { useCallback, useContext, useState } from 'react';
import { AppContext } from '../../app-context';

export const useDropdown = ({
  file,
  sortStrategy = SortOptions.NONE,
}: {
  file: string;
  sortStrategy?: SortOptions;
}) => {
  const { dropdownData, setDropdownData, loadFile } = useContext(AppContext);
  const [optionsLoaded, setOptionsLoaded] = useState(!file);
  const [isLoading, setIsLoading] = useState(false);

  const options = dropdownData[file];

  const onFocus = useCallback(
    async (ref: { mounted: boolean } = { mounted: true }) => {
      if (!optionsLoaded || !options) {
        setIsLoading(true);
        const optionsData = await loadFile(file);
        if (!ref.mounted) {
          return;
        }
        setOptionsLoaded(true);
        setDropdownData({
          ...dropdownData,
          [file]: { displayedOptions: optionsNormalize(optionsData, sortStrategy), rawOptions: optionsData },
        });
        setIsLoading(false);
      }
    },
    [
      file,
      sortStrategy,
      setIsLoading,
      setOptionsLoaded,
      dropdownData,
      optionsLoaded,
      setDropdownData,
      options,
      loadFile,
    ],
  );

  return {
    rawOptions: options?.rawOptions || [],
    options: options?.displayedOptions || [],
    onFocus,
    isLoading,
  };
};
